
import Vue from 'vue';
import { UserModel, CourseModel } from '@descomplica/dex-models';
import { Route } from 'vue-router';
import { DEFAULT_CATEGORY } from '@/helpers/category';
import { cleanTagsFromString } from '@/helpers/string';
import Analytics from '@/helpers/analytics';
import { EVENT_LABELS } from '@/helpers/analytics/labels';
import Swal from 'sweetalert2';

const getEmailFromRoute = (route: Route): string | undefined => {
  const { email: emailParam } = route.query;
  if (Array.isArray(emailParam)) return '';
  const email = cleanTagsFromString(emailParam);

  return email;
};

const shouldMigrateUser = (emailFromRoute: string | undefined, userEmail: string | undefined) => {
  if (emailFromRoute === undefined) return true;
  return emailFromRoute === userEmail;
};

export default Vue.extend({
  computed: {
    user(): UserModel {
      return this.$store.getters.currentUser;
    },

    currentCourse(): CourseModel {
      return this.$store.getters.currentCourse;
    },
  },

  created() {
    Analytics.trackEvent(EVENT_LABELS.migrationPageAccessed, {});
    this.handleUserMigration();
  },

  methods: {
    async handleUserMigration() {
      const emailFromRoute = getEmailFromRoute(this.$route);
      const userEmail = this.user.email;

      if (shouldMigrateUser(emailFromRoute, userEmail)) {
        await this.migrateUser();
        return;
      }

      this.handleUserLogout();
    },

    handleUserLogout(): void {
      this.$router.replace({ query: undefined });
      this.logoutUser();
    },

    redirectToHome(): void {
      const { descomplicaCategorySlug: categorySlug, slug: courseSlug } = this.currentCourse;
      const params = {
        category: categorySlug || DEFAULT_CATEGORY,
        currentCourse: courseSlug || '',
      };

      this.$router.push({ name: 'home', params });
    },

    async migrateUser(): Promise<void> {
      await this.$store.dispatch('UPDATE_HAS_MIGRATED_TO_CLASSROOMS');
      Swal.fire({
        title: this.$t('migrationSuccessMessage'),
        position: 'bottom-end',
        toast: true,
        showConfirmButton: true,
        confirmButtonText: this.$t('closeButton') as string,
        buttonsStyling: false,
      });

      Analytics.trackEvent(EVENT_LABELS.migrationToClassroomCompleted, {});

      this.redirectToHome();
    },
    logoutUser() {
      this.$store.commit('SIGNOUT');
      window.location.reload();
    },
  },
});
